// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getTimeParts(targetDate: Date, options?: any) {
  const now = new Date();
  const diff = targetDate.getTime() - now.getTime();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

  let diffInSeconds = Math.floor(diff / 1000);
  const result = { days: 0, hours: 0, minutes: 0, seconds: 0 };

  const showDays = options?.showDays !== false;
  const showHours = options?.showHours !== false;
  const showMinutes = options?.showMinutes !== false;

  if (showDays) {
    result.days = Math.floor(diffInSeconds / (24 * 3600));
    diffInSeconds %= 24 * 3600;
  }

  if (showHours) {
    result.hours = Math.floor(diffInSeconds / 3600);
    diffInSeconds %= 3600;
  }

  if (showMinutes) {
    result.minutes = Math.floor(diffInSeconds / 60);
    diffInSeconds %= 60;
  }

  result.seconds = diffInSeconds;
  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function calculateSimpleString(targetDate: Date, options?: any): string {
  const { days, hours, minutes, seconds } = getTimeParts(targetDate, options);
  const pad = (num: number) =>
    options?.padWithZeros === false
      ? String(num)
      : String(num).padStart(2, "0");

  const parts: string[] = [];

  if (options?.showHours !== false) {
    parts.push(pad(hours));
  }

  if (options?.showMinutes !== false) {
    parts.push(pad(minutes));
  }

  if (options?.showSeconds !== false) {
    parts.push(pad(seconds));
  }

  const time = parts.length > 0 ? parts.join(":") : "00:00";

  if (options?.showDays !== false && days > 0) {
    return `${days}d ${time}`;
  }

  return time;
}
